import { LIST_OF_FAVOURATE_INVENTORY, LIST_OF_ALL_INVENTORY, LIST_OF_ALL_SERVER_DETAILS, LIST_OF_MONITORING_PARAMS, LIST_OF_INVENTORY_ACCESS_RIGHT, ASIGN_INVENTORY_ACCESS_TO_GROUP } from "../constants/actionTypes";
import * as api from '../api/index.js';
import logMessage from "../logserver.js";
import { decryptData } from "../Components/utils/EncriptionStore";
import { toast } from 'react-toastify';

const user = (() => {
  const encryptedData = localStorage.getItem("profile");
  return encryptedData ? decryptData(encryptedData) : null;
})();


export const getFavoriteInventory = (formData, router) => async (dispatch) => {
  try {
    const { data } = await api.getFavoriteInventory({
      customer_id: user?.customer_id,
      group_id: user?.group_id,
      customer_name: user?.customer_name,
      group_name: user?.groupname,
    });
    if (data?.statusCode === 200) {
      dispatch({ type: LIST_OF_FAVOURATE_INVENTORY, data });
      logMessage(
        user?.user_email_id,
        data?.statusCode,
        data?.message || "Inventory List Fetch Successfully"
      );
    } else if (data?.statusCode === 204 || data?.statusCode === 400) {
      logMessage(
        user?.user_email_id,
        data?.statusCode,
        data?.message || "Inventory List Not Fetch"
      );
    } else {
      logMessage(
        user?.user_email_id,
        data?.statusCode,
        data?.message || "Inventory List Not Fetch"
      );
    }
  } catch (error) {
    console.log(error.message);
  }
};

export const getListOFAllInventory = (formData, router) => async (dispatch) => {
  try {
    const { data } = await api.getListOFAllInventory({
      customer_id: user?.customer_id,
      group_id: user?.group_id,
      customer_name: user?.customer_name,
      group_name: user?.groupname,
    });
    if (data?.statusCode === 200) {
      dispatch({ type: LIST_OF_ALL_INVENTORY, data });
      logMessage(
        user?.user_email_id,
        data?.statusCode,
        data?.message || "Inventory List Fetch Successfully"
      );
    } else if (data?.statusCode === 204 || data?.statusCode === 400) {
      logMessage(
        user?.user_email_id,
        data?.statusCode,
        data?.message || "Inventory List Not Fetch"
      );
    } else {
      logMessage(
        user?.user_email_id,
        data?.statusCode,
        data?.message || "Inventory List Not Fetch"
      );
    }
  } catch (error) {
    console.log(error.message);
  }
};

export const favserverdetails = (formData, router) => async (dispatch) => {
  try {
    const { data } = await api.favserverdetails(formData);
    if (data?.status === 'success') {
      dispatch({ type: LIST_OF_ALL_SERVER_DETAILS, data });
      logMessage(user?.user_email_id, data?.statusCode, data?.message || "Inventory List Fetch Successfully");
    } else if (data?.statusCode === 204 || data?.statusCode === 400) {
      logMessage(user?.user_email_id, data?.statusCode, data?.message || "Inventory List Not Fetch");
    } else {
      logMessage(user?.user_email_id, data?.statusCode, data?.message || "Inventory List Not Fetch");
    }
  } catch (error) {
    console.log(error.message);
  }
}

export const fetchMonitoringParams = (formData, router) => async (dispatch) => {
  try {
    const { data } = await api.fetchMonitoringParams(formData);
    if (data?.statusCode === "200") {
      dispatch({ type: LIST_OF_MONITORING_PARAMS, data });
      logMessage(user?.user_email_id, data?.statusCode, data?.message || "Inventory List Fetch Successfully");
    } else if (data?.statusCode === "204" || data?.statusCode === "400") {
      logMessage(user?.user_email_id, data?.statusCode, data?.message || "Inventory List Not Fetch");
    } else {
      logMessage(user?.user_email_id, data?.statusCode, data?.message || "Inventory List Not Fetch");
    }
  } catch (error) {
    console.log(error.message);
  }
}

export const fetchInventoryAccessData = (formData, router) => async (dispatch) => {
  try {
    const { data } = await api.fetchInventoryAccessData(formData);
    if (data?.statusCode === 200) {
      dispatch({ type: LIST_OF_INVENTORY_ACCESS_RIGHT, data });
      logMessage(user?.user_email_id, data?.statusCode, data?.message || "Inventory List Fetch Successfully");
    } else if (data?.statusCode === 204 || data?.statusCode === 400) {
      logMessage(user?.user_email_id, data?.statusCode, data?.message || "Inventory List Not Fetch");
    } else {
      logMessage(user?.user_email_id, data?.statusCode, data?.message || "Inventory List Not Fetch");
    }
  } catch (error) {
    console.log(error.message);
  }
}

export const asigninventorytothegroup = (formData, router) => async (dispatch) => {
  try {
    const { data } = await api.asigninventorytothegroup(formData);
    if (data?.statusCode === 200) {
      dispatch({ type: ASIGN_INVENTORY_ACCESS_TO_GROUP, data });
      toast.success(data?.content || data?.message || "Table Mapping done", { position: "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, theme: "light", });
      logMessage(user?.user_email_id, data?.statusCode, data?.content || "Inventory List Fetch Successfully");
    } else if (data?.statusCode === 204 || data?.statusCode === 400) {
      logMessage(user?.user_email_id, data?.statusCode, data?.content || "Inventory List Not Fetch");
    } else {
      logMessage(user?.user_email_id, data?.statusCode, data?.content || "Inventory List Not Fetch");
    }
  } catch (error) {
    console.log(error.message);
  }
}



